// removed by extract-text-webpack-plugin
module.exports = {"editorBlock":"BaseComponent-cssmodule-editorBlock-11Md8"};


//////////////////
// WEBPACK FOOTER
// ./components/ModalSet/BaseComponent.cssmodule.less
// module id = 647
// module chunks = 0